export default "/dist/files/icon_photos.a88504d88fb65b719615a38c770a3533.svg";